import { Grid, Typography } from "@mui/material";
import MxFormL3TextDateField from "@rf-l3/form/MxFormL3DatePickerField";
import MxFormL4DocumentFileProperty from "@/src-refactor/modules/shared/components/refactor/components/l4/form/MxFormL4DocumentFileProperty";
import MxTypography from "@rf-l1/MxTypography";
import useValidateExplicitField from "../../hooks/useValidateExplicitField";
import { useFormValidationsDocumentsMsgSlice } from "@rf/property/module/components/property-form/store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";
import useShowValidationInfo from "@rf/property/module/components/modal/useShowValidationInfo";
import { IFileData } from "@rf-l1/file/helpers/create-file-data";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { CValidationDocumentKeys } from "../../../../../../../util/model/documents-types";

const PurchaseSale = () => {
  const {
    validationDocuments: { land_purchase }
  } = useFormValidationsDocumentsMsgSlice();
  const { validateField } = useValidateExplicitField();
  const { showNotification } = useShowValidationInfo();

  const handleOnClickOnExternalIndicators = (
    file: IFileData | null,
    ctx: any,
    itemCtx: any
  ) => {
    showNotification(itemCtx.msg, itemCtx.status);
  };

  return (
    <Grid container item xs={3.2} alignSelf={"flex-start"} rowGap={1}>
     
      <Grid container item xs={12}>
        <MxFormL4DocumentFileProperty
          withreacthookform={1}
          name={CPropertyFormKeys.file_purchase_sale_land}
          label="Compra - Venta - Terreno"
          maxSize={3}
          minSize={0}
          disabled={land_purchase?.disabled}
          typeKey={CValidationDocumentKeys.LandPurchase}
        />
      </Grid>

      <Grid item xs={12}>
        <MxFormL3TextDateField
          withreacthookform={1}
          name={CPropertyFormKeys.date_file_purchase_sale_land}
          label="Indique la fecha de transferencia del título."
          disabled={land_purchase?.disabled}
        />
      </Grid>
    </Grid>
  );
};

export default PurchaseSale;
